import React from "react";

export default function Data() {
  return (
    <div className="home--data">
      <h1 className="home--title">Atul Singh</h1>
      <h3 className="home--subtitle">Frontend Developer</h3>
      <p className="home--description">
        Hello, I'm a Frontend developer and currently I'm in pre-final year of
        my college. I'm a computer science student.
      </p>
      <a href="#contact" className="button button-flex">
        say hello
        <i class="uil uil-message"></i>
      </a>
    </div>
  );
}
